import { ZKX_TRADE_ROUTED_CHAIN_IDS } from '@ambire-common/services/zkxTrade/constants'

/**
 * PulseChain leads the network section. It is no longer a special case for
 * ROUTING — ZKX Trade quotes 369 → 369 like every other chain since 2026-09-11
 * (see `zkxTrade/constants.ts` `ZKX_TRADE_EXCLUDED_CHAIN_IDS`) — but it is still
 * the chain this wallet is built around, so it is pulled to the front of the
 * list rather than left in the registry's numeric order between Monad and
 * Mantle.
 */
const DISPLAY_FIRST_CHAIN_ID = 369

/**
 * The network `/swap` opens on when nothing else chose one (no token-detail
 * "Swap" preselection). PulseChain, for the same reason it leads the list —
 * NOT the chain of the curated USDC(Base) bridge pair (Trello #510).
 */
export const SWAP_DEFAULT_CHAIN_ID = DISPLAY_FIRST_CHAIN_ID

/**
 * The chains the `/swap` (same-chain) screen offers in its network section, in
 * display order.
 *
 * A chain belongs here only when a provider can actually quote a same-chain pair
 * on it, so the picker can never park the form on a network that answers "not
 * supported by any available service provider".
 *
 * `/bridge` does NOT use this list — it keeps the full cross-chain network set.
 */
export const SAME_CHAIN_SWAP_CHAIN_IDS: number[] = [
  ...ZKX_TRADE_ROUTED_CHAIN_IDS.filter((chainId) => chainId === DISPLAY_FIRST_CHAIN_ID),
  ...ZKX_TRADE_ROUTED_CHAIN_IDS.filter((chainId) => chainId !== DISPLAY_FIRST_CHAIN_ID)
]

/**
 * Whether a same-chain pair sourced from `chainId` can be routed at all. This
 * reads the SAME list the network section offers, deliberately: the two used to
 * be derived separately, which let the picker offer PulseChain while the form
 * refused to pin the destination to it, leaving `/swap` building a cross-chain
 * pair behind a screen that says "Swap".
 */
export const isSameChainSwapNetwork = (chainId: number | bigint): boolean =>
  SAME_CHAIN_SWAP_CHAIN_IDS.includes(Number(chainId))
